module.exports = __webpack_public_path__ + "static/media/logo-dark.7d8c58eb.png";